var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,31H16a1,1,0,0,1-1-1V27a2,2,0,0,0-4,0v3a1,1,0,0,1-1,1H4a3,3,0,0,1-3-3V22a1,1,0,0,1,1-1H5a2,2,0,0,0,0-4H2a1,1,0,0,1-1-1V10A3,3,0,0,1,4,7H9V5a4,4,0,0,1,8,0V7h5a3,3,0,0,1,3,3v5h2a4,4,0,0,1,0,8H25v5A3,3,0,0,1,22,31Zm-5-2h5a1,1,0,0,0,1-1V22a1,1,0,0,1,1-1h3a2,2,0,0,0,0-4H24a1,1,0,0,1-1-1V10a1,1,0,0,0-1-1H16a1,1,0,0,1-1-1V5a2,2,0,0,0-4,0V8a1,1,0,0,1-1,1H4a1,1,0,0,0-1,1v5H5a4,4,0,0,1,0,8H3v5a1,1,0,0,0,1,1H9V27a4,4,0,0,1,8,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.6d8ea283ddc1cef4e5dcd4664dc24593.svg";
export { ForwardRef as ReactComponent };